import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import EditHolidays from "../EditHolidays";
import HolidaysDelete from "./HolidaysDelete";
import CustomTooltip from "../../../common/CustomTooltip";

const HolidaysActionButton = ({ id, holidaysModal }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showHolidays, setShowHolidays] = useState(false);

  const toggleHolidaysModal = () => {
    showHolidays && holidaysModal();

    setShowHolidays(!showHolidays);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        {/* <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#clientDetail"
        /> */}
        {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp; */}
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={toggleHolidaysModal}
            />
          </span>
        </CustomTooltip>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleDeleteModal}
              icon={faTrash}
              size="1x"
              data-toggle="modal"
              data-target="#deleteClient"
            />
          </span>
        </CustomTooltip>
      </span>

      {showDelete && (
        <HolidaysDelete
          holidaysId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={holidaysModal}
          showDelete={showDelete}
        />
      )}

      {showHolidays && (
        <EditHolidays
          holidaysId={id}
          showHolidays={showHolidays}
          toggleHolidaysModal={toggleHolidaysModal}
        />
      )}

      {/* {showView && (
        <HolidaysDetailPopup
          showView={showView}
          holidaysId={id}
          toggleShowModal={toggleShowModal}
        />
      )} */}
    </>
  );
};

export default HolidaysActionButton;
